const settings = {
  websiteURL: `https://presentation.thenorthliving.com/`,
  username: `wciwebadmin`,
  password: `xwP5!)yDdPyK!%yU2EBY%xbO`,
  contentType: `application/json`,
};

export default settings;
